import React, { useCallback, useEffect, useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";

function Detallstipusmaobra({
  mode,
  tipus,
  tipusLlista,
  onNavigate,
  onSave,
  onCancel,
  onCanviarMode,
  onDeleted,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";
  TeclaEscEnter(onCancel, null);
  const { empresaSeleccionada, rolUsuari } = useUserContext();

  const [nomTipus, setNomTipus] = useState("");
  const [preuHoraBase, setPreuHoraBase] = useState("30.00");
  const [actiu, setActiu] = useState(true);
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const resetForm = useCallback(() => {
    setNomTipus("");
    setPreuHoraBase("30.00");
    setActiu(true);
  }, []);

  useEffect(() => {
    if (tipus && mode !== "nou") {
      setNomTipus(tipus.Tipus || "");
      setPreuHoraBase(
        tipus.PreuHoraBase != null && tipus.PreuHoraBase !== "" ? String(tipus.PreuHoraBase) : "30.00"
      );
      setActiu(Number(tipus.Actiu) === 1 || tipus.Actiu === true);
    } else if (mode === "nou") {
      resetForm();
    }
    setMenuAccions(false);
  }, [tipus, mode, resetForm]);

  const llista = Array.isArray(tipusLlista) ? tipusLlista : [];
  const indexActual = tipus
    ? llista.findIndex((t) => Number(t.idTipusMaObra) === Number(tipus.idTipusMaObra))
    : -1;
  const potNavegar = ["consultar", "modificar"].includes(mode) && llista.length > 1 && indexActual >= 0;

  const anarAnterior = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === 0 ? llista.length - 1 : indexActual - 1;
    onNavigate?.(llista[nouIndex]);
  };

  const anarSeguent = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === llista.length - 1 ? 0 : indexActual + 1;
    onNavigate?.(llista[nouIndex]);
  };

  const payload = () => ({
    idEmpresa: empresaSeleccionada?.IdEmpresa || null,
    Tipus: nomTipus.trim(),
    PreuHoraBase: preuHoraBase === "" ? null : Number(preuHoraBase),
    Actiu: actiu,
  });

  const validar = () => {
    const errors = [];
    if (!nomTipus.trim()) errors.push("El camp Tipus és obligatori.");
    if (preuHoraBase === "" || Number.isNaN(Number(preuHoraBase))) {
      errors.push("El preu hora base és obligatori.");
    } else if (Number(preuHoraBase) < 0) {
      errors.push("El preu hora base no pot ser negatiu.");
    }
    return errors;
  };

  const handleSubmit = async () => {
    if (mode !== "esborrar") {
      const errors = validar();
      if (errors.length > 0) {
        alert(`Errors trobats:\n${errors.join("\n")}`);
        return;
      }
    }

    try {
      if (mode === "nou") {
        const resp = await fetch(`${API_URL}/Noutipusmaobra.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload()),
        });
        const data = await resp.json();
        if (data.success) {
          onSave?.({
            idTipusMaObra: data.idTipusMaObra,
            Tipus: nomTipus.trim(),
            PreuHoraBase: payload().PreuHoraBase,
            Actiu: actiu ? 1 : 0,
          });
        } else {
          alert(data.message || "Error en crear el tipus.");
        }
      } else if (mode === "modificar") {
        const body = { ...payload(), idTipusMaObra: tipus.idTipusMaObra };
        const resp = await fetch(`${API_URL}/Modificartipusmaobra.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        const data = await resp.json();
        if (data.success) {
          onSave?.({ ...tipus, ...body, Actiu: actiu ? 1 : 0 });
        } else {
          alert(data.message || "Error en modificar el tipus.");
        }
      } else if (mode === "esborrar") {
        const resp = await fetch(`${API_URL}/Esborrartipusmaobra.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa || null,
            idTipusMaObra: tipus.idTipusMaObra,
          }),
        });
        const data = await resp.json();
        if (data.success) {
          onDeleted?.();
        } else {
          alert(data.message || "Error en esborrar el tipus.");
        }
      }
    } catch (err) {
      console.error(err);
      alert("S'ha produït un error en el procés.");
    }
  };

  const titol =
    mode === "nou"
      ? "Nou tipus de mà d'obra"
      : mode === "esborrar"
      ? "Esborrar tipus de mà d'obra"
      : mode === "modificar"
      ? "Modificar tipus de mà d'obra"
      : "Tipus de mà d'obra · Fitxa";

  const subtitol =
    mode === "nou"
      ? "Introdueix el nom, el preu hora i si està actiu."
      : mode === "esborrar"
      ? "Si ja s'usa en grups, empleats o historial, no es podrà esborrar; en aquest cas desactiva'l."
      : nomTipus || "Dades del tipus";

  const camp = (label, required, content, mida = "mig") => {
    const extra =
      mida === "ample" ? "dv2-field--ample" : mida === "llarg" ? "dv2-field--llarg" : mida === "curt" ? "dv2-field--curt" : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </label>
    );
  };

  const toggle = (checked, onChange) => (
    <span className="dv2-toggleRow">
      <span className="dv2-toggle">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
        <span className="dv2-toggle-track" />
      </span>
    </span>
  );

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaMestres pestanya="tipusmaobra" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "🧰"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titol}</h1>
            <p className="dv2-pageHeader-subtitle">{subtitol}</p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funcionen els Tipus de mà d'obra" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && tincPermis(rolUsuari, "MODIFICAR") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && tincPermis(rolUsuari, "ESBORRAR") && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  <button
                    type="button"
                    className="dv2-menu-item is-danger"
                    onClick={() => {
                      setMenuAccions(false);
                      onCanviarMode?.("esborrar");
                    }}
                  >
                    Esborrar
                  </button>
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar tipus
            </button>
          )}
        </div>
      </div>

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si el tipus s'usa en grups, empleats o historial, el servidor no el deixarà esborrar.
        </div>
      )}

      <div className="dv2-entity-body">
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">1</span>
            <h2 className="dv2-card-title">Dades bàsiques</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Tipus",
              true,
              isReadOnly ? (
                <span className="dv2-value">{nomTipus || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={nomTipus} maxLength={100} autoFocus onChange={(e) => setNomTipus(e.target.value)} />
              ),
              "llarg"
            )}
            {camp(
              "Preu hora base",
              true,
              isReadOnly ? (
                <span className="dv2-value">
                  {preuHoraBase !== "" ? `${Number(preuHoraBase).toFixed(2)} €/h` : "—"}
                </span>
              ) : (
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  className="dv2-input"
                  value={preuHoraBase}
                  onChange={(e) => setPreuHoraBase(e.target.value)}
                />
              ),
              "curt"
            )}
            {camp(
              "Actiu",
              false,
              isReadOnly ? <span className="dv2-value">{actiu ? "Sí" : "No"}</span> : toggle(actiu, setActiu),
              "curt"
            )}
          </div>
        </section>
      </div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarAnterior} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {indexActual + 1} / {llista.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarSeguent} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar tipus
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar tipus" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallstipusmaobra;
